import { AggregatedConfigurations } from './AggregatedConfigurations';
import { SegmentWithHeader } from '@app/shared';
import { ScrollableContentContainer } from '../components/ScrollableContentContainer';
import { JsonViewer } from '@textea/json-viewer';
import React from 'react';
import { ComponentErrorBoundary } from '@app/utilities';
import { Product } from '@app/models';

export function ProductDetail({ product }: { product: Product }) {
  return (
    <ComponentErrorBoundary>
      <SegmentWithHeader header={product && `Product: ${product.label}`} className={'basic'}>
        <ScrollableContentContainer className={'basic'} height={'300px'} style={{ border: 'thin solid lightgray' }}>
          {product && <JsonViewer value={product} />}
        </ScrollableContentContainer>
      </SegmentWithHeader>
      <SegmentWithHeader className={'basic'} header={`Aggregated Configurations`}>
        <ScrollableContentContainer height={'350px'}>
          {product?.organisationUnitId && (
            <AggregatedConfigurations ouId={product.organisationUnitId} category={'Product'} />
          )}
        </ScrollableContentContainer>
      </SegmentWithHeader>
    </ComponentErrorBoundary>
  );
}
